import cookies from 'js-cookie';

const DEFAULT_COOKIE_NAME = 'tracking-preferences';

export function isMarketingEnabled(cookieName?: string): boolean {
	const cookie = cookies.get(cookieName || DEFAULT_COOKIE_NAME);

	if (!cookie) {
		return false;
	}

	try {
		const preferences = JSON.parse(decodeURIComponent(cookie));

		if (!preferences?.custom?.marketingAndAnalytics) {
			return false;
		}
	} catch (error) {
		// eslint-disable-next-line no-restricted-syntax
		console.error('COOKIE ERR', error);

		return false;
	}

	return true;
}
